import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    form: {
      display: "flex",
      alignItems: "center",
      maxWidth: "210px",
    },
    select: {
      "& input": {
        padding: theme.spacing(2.5, 8),
      },
    },
  }),
);
